// src/utils/credits.js
import { db } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

export const deductCredits = async (userId, amount) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) {
      throw new Error('User not found');
    }

    const userData = userSnap.data();
    if (userData.credits < amount) {
      throw new Error('Insufficient credits');
    }

    await updateDoc(userRef, {
      credits: userData.credits - amount,
    });
    return true;
  } catch (err) {
    console.error('Error deducting credits:', err);
    throw err;
  }
};

export const addCredits = async (userId, amount) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) {
      throw new Error('User not found');
    }

    const userData = userSnap.data();
    await updateDoc(userRef, {
      credits: userData.credits + amount,
    });
    return true;
  } catch (err) {
    console.error('Error adding credits:', err);
    throw err;
  }
};